/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InvalidateNbaCacheRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/next_best_action_messages.pb'
import {InvalidateNbaCacheResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/next_best_action_messages.pb'


export const invalidateNbaCache = (request: InvalidateNbaCacheRequest, options?: CashRequestOptions) => post<InvalidateNbaCacheRequest, InvalidateNbaCacheResponse>("/2.0/cash/invalidate-nba-cache", request, {...options, rejectOnError: true })